import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import LineChart from "../../Charts/LineChart";
import AssignmentChart from "../../Charts/AssignmentChart";
import AppModal from "../../Applications/UpdateApplicationModal"
import CloseWarningModal from "../../Misc/CloseWarningModal";
import WaterSavingsLog from "../../Applications/WaterSavingsLog";
import Header from "../../Applications/Header";
import Application from "../../Applications/ApplicationFieldAssignment";
import Paginate from "../../Misc/Paginate";
import ApplicationTableFilterModal from "../../Applications/ApplicationTableFilterModal";

import {
  paginateByStatusName,
  selectApplicationCount,
  searchByFilterText,
  searchByAssignmentId,
  fetchApplicationChunks,
  exportApplicationByProgramId,
  fetchApplicationCountByProgram,
  fetchApplicationCountByProgramSearch,
} from "../../../features/application";
import { selectAllStatus } from "../../../features/applicationStatus";
import { selectAllPrograms } from "../../../features/program";
import { selectAllUsers } from "../../../features/user";
import ProgramSummary from "../../Home/ProgramSummary";
import { useDispatch, useSelector } from "react-redux";
import { selectAllCustomers } from "../../../features/customer";
import { selectAllValues } from "../../../features/applicationValue";
import { selectAllProperties } from "../../../features/properties";
import { selectAllFields } from "../../../features/programField";
import { formatFullAddress } from "../../../utils/formatAddress";
import { selectStatusLogs, selectStatusList, getStatusFilterNames } from "../../../features/status";

import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
} from "react-icons/ti";


const axios = require("axios").default;
axios.defaults.headers.common["Client"] = "ACWD";

const FieldAssignmentsContainer = ({ props }) => {
  const dispatch = useDispatch();

  const properties = useSelector(selectAllProperties);
  const appValues = useSelector(selectAllValues);
  const fieldList = useSelector(selectAllFields);
  const applicationCount = useSelector(selectApplicationCount);

  const [propertyLookup, setPropertyLookup] = useState(new Map());
  const [customerLookup, setCustomerLookup] = useState(new Map());
  const [programLookup, setProgramLookup] = useState(new Map());
  const [statusListLookup, setStatusListLookup] = useState(new Map());
  const [targetApplications, setTargetApplications] = useState([]);

  const [filterType, setFilterType] = useState("");
  const [filterText, setFilterText] = useState("");

  const [triggerRefresh, setTriggerRefresh] = useState(false);
  const [loadingApps, setLoadingApps] = useState(false);
  const [filterCount, setFilterCount] = useState(null);
  const [lookupsReady, setLookupsReady] = useState(false);

  const [filterOptions, setFilterOptions] = useState([]);
  const [sortOptions, setSortOptions] = useState({});
  const [showFilterModal, setShowFilterModal] = useState({});
  const [showFilterData, setShowFilterData] = useState([]);

  const [numberFilterList, setNumberFilterList] = useState(null);
  const [nameFilterList, setNameFilterList] = useState(null);

  const [applicationTotal, setApplicationTotal] = useState(applicationCount);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const getStatusFilters = async () => {
      let res = await dispatch(getStatusFilterNames({ column: "number" }));
      const numberObj = res.payload.map((x) => {
        return { status: x };
      });
      setNumberFilterList(numberObj);

      res = await dispatch(getStatusFilterNames({ column: "name" }));
      const nameObj = res.payload.map((x) => {
        return { currentStatus: x };
      });
      setNameFilterList(nameObj);
    };

    getStatusFilters();
  }, []);

  const [modalController, setModalController] = useState(
    {
      appModal: false,
      modalCustomerId: null,
      modalAppId: null,
      openAppModal: (payload) => {
        setModalController((prev) => ({
          ...prev,
          appModal: true,
          modalCustomerId: payload?.customerId,
          modalAppId: payload.appId,
          programId: payload.programId,
          property: payload.property,
          app: payload.app,
        }));
      },
      closeAppModal: () => {
        setModalController((prev) => ({
          ...prev,
          appModal: false,
        }));
      },
      closeWarning: false,
      openWarningModal: () => {
        setModalController((prev) => ({
          ...prev,
          closeWarning: true,
        }));
      },
      closeWarningModal: () => {
        setModalController((prev) => ({
          ...prev,
          closeWarning: false,
        }));
      },
    },
    []
  );

  const [appData, setAppData] = useState(
    {
      customerList: useSelector(selectAllCustomers),
      customer: null,
      setCustomer: (customer) => {
        setAppData((prev) => ({
          ...prev,
          customer: customer,
        }));
      },
      values: useSelector(selectAllValues),
      appValues: null,
      setAppValues: (values) => {
        setAppData((prev) => ({
          ...prev,
          appValues: values,
        }));
      },
      properties: useSelector(selectAllProperties),
      property: null,
      setProperty: (property) => {
        setAppData((prev) => ({
          ...prev,
          property: property,
        }));
      },
      programs: useSelector(selectAllPrograms),
      program: null,
      setProgram: (program) => {
        setAppData((prev) => ({
          ...prev,
          program: program,
        }));
      },
      fields: useSelector(selectAllFields),
      appStatus: null,
      setAppStatus: (status) => {
        setAppData((prev) => ({
          ...prev,
          appStatus: status,
        }));
      },
      statusList: useSelector(selectStatusList),
      allStatus: useSelector(selectAllStatus),
      statusObj: null,
      statusLogs: useSelector(selectStatusLogs),
      users: useSelector(selectAllUsers),
      setStatus: (status) => {
        setAppData((prev) => ({
          ...prev,
          statusObj: status,
        }));
      },
      // applications: useSelector(selectAllApplications),
    },
    []
  );

  useEffect(() => {
    if (lookupsReady) {
      if (sortOptions.column) {
        filterByCurrentStatus(sortOptions.column, sortOptions.sort);
      } else if (
        !sortOptions.column &&
        filterText.length > 0 &&
        filterType.length > 0
      ) {
        searchFilterText();
      } else {
        // filterByCurrentStatus("id", "desc");
        showMyAssignments();
      }

      if (triggerRefresh) setTriggerRefresh(false);
    }
  }, [
    lookupsReady,
    filterOptions,
    sortOptions,
    filterText,
    filterType,
    currentPage,
    triggerRefresh,
  ]);

  useEffect(() => {
    setPropertyLookup(new Map(properties?.map((prop) => [prop.id, prop])));
    setCustomerLookup(
      new Map(appData.customerList?.map((cust) => [cust.id, cust]))
    );
    setProgramLookup(new Map(appData.programs?.map((prog) => [prog.id, prog])));
    setStatusListLookup(
      // new Map(
      //   appData.statusList?.map((status) => [
      //     `${status.number}-${status.programId}`,
      //     status,
      //   ])
      // )
      new Map(
        appData.statusList?.map((status) => [
          `${status.id}-${status.programId}`,
          status,
        ])
      )
    );
  }, [properties, appData.customerList, appData.programs, appData.statusList]);

  useEffect(() => {
    if (
      propertyLookup.size > 0 &&
      customerLookup.size > 0 &&
      programLookup.size > 0 &&
      statusListLookup.size > 0
    ) {
      setLookupsReady(true);
    }
  }, [propertyLookup, customerLookup, programLookup, statusListLookup]);

  const filterByCurrentStatus = async (column, sort) => {
    try {
      console.log("filter-by-current-status");
      // setLoadingApps(true);
      if (props.view === "property") {
        //temp fix check why undefined values are coming in from array
        console.log("applications-property: ", props.applications);
        const filteredArray = props.applications.filter(
          (element) => element !== undefined
        );

        configureTargetApps(filteredArray);
      } else {
        console.log(
          "filter-options, on filter by current status: ",
          filterOptions
        );

        console.log("FILTER-OPTIONS", filterOptions);
        let programFilters = [];
        let statusFilters = [];
        let currentStatus = [];
        let assignedTo = [];
        if (filterOptions?.programName?.length > 0) {
          programFilters = [...filterOptions.programName];
        }
        if (filterOptions?.status?.length > 0) {
          statusFilters = [...filterOptions.status];
        }
        if (filterOptions?.currentStatus?.length > 0) {
          currentStatus = [...filterOptions.currentStatus];
        }
        if (filterOptions?.assignedTo?.length > 0) {
          assignedTo = [...filterOptions.assignedTo];
        }

        const filters = {
          programName: programFilters,
          status: statusFilters,
          currentStatus,
          assignedTo,
        };

        const count = await dispatch(
          fetchApplicationCountByProgram({ programFilters: programFilters })
        );

        if (count.payload) {
          setFilterCount(count.payload[0].applicationCount);
        }
        const res = await dispatch(
          paginateByStatusName({
            pageSize: 50,
            page: currentPage,
            orderBy: sort,
            orderVar: column,
            filters,
          })
        );

        console.log("paginate-by-status-name: ", res);

        configureTargetApps(res.payload);
      }
      // setLoadingApps(false);
    } catch (err) {
      console.log(err);
    }
  };

  const searchFilterText = async (column, sort) => {
    try {
      setLoadingApps(true);
      if (props.view === "property") {
        configureTargetApps(props.applications);
      } else {
        let programFilters = [];
        let statusFilters = [];
        let currentStatus = [];
        let assignedTo = [];
        if (filterOptions?.programName?.length > 0) {
          programFilters = [...filterOptions.programName];
        }
        if (filterOptions?.status?.length > 0) {
          statusFilters = [...filterOptions.status];
        }
        if (filterOptions?.currentStatus?.length > 0) {
          currentStatus = [...filterOptions.currentStatus];
        }
        if (filterOptions?.assignedTo?.length > 0) {
          assignedTo = [...filterOptions.assignedTo];
        }

        const filters = {
          programName: programFilters,
          status: statusFilters,
          currentStatus,
          assignedTo,
        };

        const count = await dispatch(
          fetchApplicationCountByProgramSearch({ filterText: filterText })
        );

        if (count.payload) {
          setFilterCount(count.payload[0].applicationCount);
        }

        const res = await dispatch(
          searchByFilterText({
            pageSize: 50,
            page: currentPage,
            filterType: filterType,
            filterText: filterText,
            filters,
          })
        );
        configureTargetApps(res.payload);
        // setFilterCount(res.payload.length);
      }
      setLoadingApps(false);
    } catch (err) {
      console.log(err);
    }
  };

  const [updateState, setUpdateState] = useState(0);
  const update = () => {
    setUpdateState(updateState + 1);
  };

  const displayProperties = targetApplications
    .filter((x) => {
      return x.status || x.customerId === "";
    })
    .map((app, index) => {
      return (
        <Application
          props={{
            app: app,
            index: index,
            modalController: modalController,
            properties: properties,
            updateState: updateState,
            view: props.view,
          }}
          index={index}
          key={index}
        />
      );
    });

  const determineShowFilterData = (payload) => {
    if (payload === "programName") {
      setShowFilterData([...appData.programs]);
    } else if (payload === "status") {
      setShowFilterData([...numberFilterList]);
    } else if (payload === "currentStatus") {
      setShowFilterData([...nameFilterList]);
    } else if (payload === "assignedTo") {
      const temp = appData.users.map((x) => {
        return {
          assignedTo: `${x.firstName} ${x.lastName}`,
        };
      });
      setShowFilterData([...temp]);
    }
  };

  const configureTargetApps = async (applications) => {
    let tmpArray = [];
    applications?.forEach((application) => {
      const statusLog = //most recent status log
        application?.statusLog && application?.statusLog?.length > 0
          ? application?.statusLog[0]
          : null;
      const tmpProp = propertyLookup.get(application?.propertyId);
      const tmpCustomer = customerLookup.get(application?.customerId);
      const tmpProgram = programLookup.get(application?.programId);
      const tmpStatusId = statusLog?.statusNumber;
      const tmpStatusIdReal = statusLog?.statusId;

      const tmpStatus = statusListLookup.get(
        `${tmpStatusIdReal}-${application?.programId}`
      );
      console.log("tmpStatus: ", tmpStatus);
      let tmpUser = statusLog?.staffAssignmentId
        ? appData?.users?.filter(
          (y) => y?.id === statusLog?.staffAssignmentId
        )[0]
        : "";
      let tmpRow = {
        id: application?.id || "",
        customerId: application.customerId || "",
        propertyId: tmpProp,
        cost: application?.cost,
        programId: application?.programId,
        waterSavings: application?.waterSavings,
        waterSavingsOverride: application?.waterSavingsOverride,
        date: application?.createdAt.split("T")[0] || "",
        address: tmpProp?.location
          ? formatFullAddress([
            tmpProp?.location?.houseNo,
            tmpProp?.location?.streetPfxDir,
            tmpProp?.location?.streetNm,
            tmpProp?.location?.streetNmSfx,
            tmpProp?.location?.streeSfxDir,
            tmpProp?.location?.secAddrId,
            tmpProp?.location?.secAddrRange,
            tmpProp?.location?.city,
            tmpProp?.location?.provinceCd,
            tmpProp?.location?.postalCode,
          ])
          : formatFullAddress([
            tmpProp?.mfcStreetNo,
            tmpProp?.streetPfxDir,
            tmpProp?.mfcStreetName,
            tmpProp?.streetNmSfx,
            tmpProp?.streetSfxDir,
            tmpProp?.secAddrId,
            tmpProp?.secAddrRange,
            tmpProp?.city,
            tmpProp?.provinceCd,
            tmpProp?.postalCode,
          ]),
        name: tmpCustomer
          ? tmpCustomer?.firstName + " " + tmpCustomer?.lastName
          : "",
        programName: tmpProgram?.programName.trim() || "",
        grantFundedAmount: application?.grantFundedAmount,
        statusObj: tmpStatus,
        status: tmpStatus?.number.trim() || "",
        currentStatus: tmpStatus?.name.trim() || "",
        statusDate: statusLog?.createdAt.split("T")[0] || "",
        assignedTo: tmpUser
          ? (tmpUser?.firstName + " " + tmpUser?.lastName).trim()
          : "",
      };
      tmpArray.push(tmpRow);
    });

    if (filterType && filterText && props.view === "property") {
      let filterBy = "";
      if (filterType === "Name") filterBy = "name";
      else if (filterType === "Program") filterBy = "programName";
      else if (filterType === "Property") filterBy = "address";
      const filteredApps = tmpArray.filter((x) => {
        return x[filterBy].toLowerCase().includes(filterText.toLowerCase());
      });
      setTargetApplications(filteredApps);
    } else {
      setTargetApplications(tmpArray);
    }
  };



  const [waterSavingsController, setWaterSavingsController] = useState({
    waterSavingsModal: false,
    openWaterSavingsModal: () => {
      setWaterSavingsController((prev) => ({
        ...prev,
        waterSavingsModal: true,
      }));
    },
    closeWaterSavingsModal: () => {
      setWaterSavingsController((prev) => ({
        ...prev,
        waterSavingsModal: false,
      }));
    },
  });



  const showMyAssignments = async () => {
    try {
      setLoadingApps(true);
      if (props.view === "property") {
        configureTargetApps(props.applications);
      } else {
        const res = await dispatch(
          searchByAssignmentId({
            pageSize: 50,
            page: currentPage,
            filterType: filterType,
            customerId: localStorage.getItem("user_id"),
          })
        );
        configureTargetApps(res.payload);

        setFilterCount(res.payload.length);
        setApplicationTotal(res.payload.length);
      }
      setLoadingApps(false);
    } catch (err) {
      console.log(err);
    }
  };

  const genSortButtons = (input) => {
    return (
      <>
        {sortOptions.column != input && (
          <TiArrowUnsorted
            onClick={(e) => {
              setSortOptions({ column: input, sort: "desc" });
            }}
            className="flex flex-col ml-auto cursor-pointer"
          />
        )}
        {sortOptions.column == input && sortOptions.sort == "asc" && (
          <TiArrowSortedUp
            onClick={(e) => {
              setSortOptions({ column: input, sort: "desc" });
            }}
            className="flex flex-col ml-auto fill-red-400 cursor-pointer"
          />
        )}
        {sortOptions.column == input && sortOptions.sort != "asc" && (
          <TiArrowSortedDown
            onClick={(e) => {
              setSortOptions({ column: input, sort: "asc" });
            }}
            className="flex flex-col ml-auto fill-red-400 cursor-pointer"
          />
        )}
      </>
    );
  };



  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className={`application-table bg-white dark:bg-gray-800 dark:text-white rounded duration-400 ease-in-out transition-spacing font-sans flex flex-col gap-4 mb-6`}
    >
      {modalController.appModal && (
        <AppModal
          props={{
            modalController: modalController,
            waterSavingsController: waterSavingsController,
            setTriggerRefresh,
            update: update,
          }}
        />
      )}
      {waterSavingsController.waterSavingsModal && (
        <WaterSavingsLog
          props={{
            modalController: modalController,
            waterSavingsController: waterSavingsController,
          }}
        />
      )}
      {modalController.closeWarning && (
        <CloseWarningModal
          props={{
            closeWarningModal: modalController.closeWarningModal,
            closeAppModal: modalController.closeAppModal,
          }}
        />
      )}

      {/* {props.view && (
        <Header
          props={{
            setFilterType: setFilterType,
            setFilterText: setFilterText,
            setFilterOptions: setFilterOptions,
            setSortOptions: setSortOptions,
            showMyAssignments: showMyAssignments,
            setTriggerRefresh,
            sortOptions: sortOptions,
            view: props.view,
          }}
        />
      )}
      <hr /> */}

      {/* current column heads are hardcoded for sorting. need to find an elegant way to provide this to the component */}
      <div className="overflow-auto w-full text-white rounded border border-gray-100 mt-1 max-h-[50rem]">
        <h2 className="w-full rounded-t tracking-wide text-gray-900 p-2 mb-2 font-medium text-lg">
          Field Assignments
        </h2>
        <table className="font-sans shadow w-full">
          <thead className="border-b-2 border-gray-200 bg-wc-green sticky top-0">
            <tr>
              <th className="p-2 py-1 text-sm font-semibold tracking-wider text-start border-r border-gray-50 w-1/12">
                <span className="flex flex-col cursor-pointer">
                  App ID
                </span>
                {genSortButtons("id")}
              </th>

              <th className="p-2 border-r border-gray-50 text-sm font-semibold tracking-wider text-start w-1/12">
                <span className="flex flex-col cursor-pointer">
                  Property Address
                </span>
                {genSortButtons("address")}
              </th>

              <th className="p-2 border-r border-gray-50 text-sm font-semibold tracking-wider text-start w-1/12">
                <span className="flex flex-col cursor-pointer">
                  Applicant Name
                </span>
                {genSortButtons("name")}
              </th>
              <th className="p-2 border-r border-gray-50 text-sm font-semibold tracking-wider text-start w-1/12">
                <span
                  className="flex flex-col cursor-pointer"
                  onClick={(e) => {
                    setShowFilterModal((prev) => ({
                      ...prev,
                      type: "programName",
                      show: 1,
                    }));

                    determineShowFilterData("programName");
                  }}
                >
                  Program Name
                </span>
                {genSortButtons("programName")}
              </th>
              {props.view === "fieldAssignments" && (
                <th
                  className={
                    "p-2 border-r border-gray-50 text-sm font-semibold tracking-wider text-start w-1/12" +
                    (Object.keys(filterOptions)[0] == "status"
                      ? "bg-blue-400"
                      : "")
                  }
                >
                  <span
                    className="flex flex-col cursor-pointer"
                    onClick={(e) => {
                      setShowFilterModal((prev) => ({
                        ...prev,
                        type: "status",
                        show: 1,
                      }));

                      determineShowFilterData("status");
                    }}
                  >
                    Status #
                  </span>
                  {genSortButtons("status")}
                </th>
              )}

              <th className="p-2 border-r border-gray-50 text-sm font-semibold tracking-wider text-start w-1/12">
                <span
                  className="flex flex-col cursor-pointer"
                  onClick={(e) => {
                    setShowFilterModal((prev) => ({
                      ...prev,
                      type: "currentStatus",
                      show: 1,
                    }));

                    determineShowFilterData("currentStatus");
                  }}
                >
                  Current Status
                </span>
                {genSortButtons("currentStatus")}
              </th>
            </tr>
          </thead>

          {loadingApps === false ? (
            <tbody className="divide-y">{displayProperties}</tbody>
          ) : (
            <span className="text-black">loading...</span>
          )}
        </table>
      </div>
      {applicationTotal && (
        <Paginate
          props={{
            totalItems: applicationTotal,
            itemsPerPage: 50,
            setCurrentPage: setCurrentPage,
          }}
        />
      )}

      {showFilterModal?.show == 1 && (
        <ApplicationTableFilterModal
          props={{
            closeModal: setShowFilterModal,
            data: showFilterData,
            filter: showFilterModal.type,
            setFilter: setFilterOptions,
            filterOptions: filterOptions,
          }}
        />
      )}
    </motion.div>
    // <div
    //   className={` bg-white dark:bg-gray-900 transistion duration-200 font-sans dark:text-gray-50 md:p-8 ${
    //     props.sidebarOpen ? "md:ml-[15rem]" : "md:ml-[4rem]"
    //   }`}
    // >
    //   <div className="main-content overflow-auto">
    //     <div className="p-3 md:p-8">
    //       <h2 className="w-full rounded-t tracking-wide text-gray-900 mb-8 font-medium text-lg">
    //         Field Assignments
    //       </h2>
    //     </div>
    //   </div>
    // </div>
  );
}

export default FieldAssignmentsContainer;